<template>
  <a-modal
    :title="title"
    :visible="unitVisible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table
             bordered
             :columns="columns"
             :data-source="list"
             :pagination="false"
             :loading="loading">
    </a-table>
<!--    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />-->
    <div style="height: 25px">

    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleExport">
          导出
        </a-button>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import { unitCount } from '@/api/order/sell'

export default {
  name: 'ChangeLog',
  data() {
    return {
      title:undefined,
      loading: false,
      unitVisible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: undefined,
      list: [],
      columns: [
        {
          title: '实际商品数量',
          dataIndex: 'goodsUnitCount',
        },
        {
          title: '订单数',
          dataIndex: 'orderCount',
        }
      ],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.unitVisible=false
      this.list=[]
      this.reset()
    },

    reset() {
      this.queryParam = undefined
    },
    /** 修改按钮操作 */
    handleUnitCount(queryParam) {
      this.reset()
      this.queryParam = queryParam
      unitCount(queryParam).then(response => {
        this.list = response.data
        this.total = response.data.length
        this.loading = false
        this.unitVisible = true;
      })
    },
    handleExport() {
      var that = this
      that.download('order/sell/unit/count/export',
        that.queryParam, `订单量_${new Date().getTime()}.xlsx`)
    },
  }
}
</script>
